import apiService from '../../../apiService'
import constants from '../../../../../../../../resources/js/constants'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    fetching: true,
    privileges: {},
    services: {},
    nextStep: {}
  },
  mutations: {
    setPrivileges (state, payload) {
      state.privileges = payload
    },
    setServices (state, payload) {
      state.services = payload
    },
    setNextStep (state, payload) {
      state.nextStep = payload
    }
  },
  actions: {
    fetch ({ state, commit }, domain) {
      state.fetching = true

      apiService.getFormsLoyaltyProgramMap(domain)
        .then(response => {
          commit('setPrivileges', response.data.privileges)
          commit('setServices', response.data.services)
          commit('setNextStep', response.data.next_step)

          state.fetching = false
        })
        .catch(() => {
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список доступных услуг по программе лояльности.'
          })
        })
    },
    connectPrivilege ({ state }, symbolName) {
      const privilege = state.privileges.not_connected.find(p => p.symbol_name === symbolName)

      if (privilege) {
        state.privileges.not_connected = state.privileges.not_connected.filter(p => p.symbol_name !== symbolName)
        state.privileges.connected.push(privilege)
      }
    }
  },
  getters: {
    getPrivilegesConnected: state => type => {
      if (Object.prototype.hasOwnProperty.call(state.privileges, 'connected')) {
        if (type) {
          return state.privileges.connected.filter(privilege => privilege.type === type)
        }

        return state.privileges.connected
      }

      return []
    },
    getPrivilegesNotConnected: state => type => {
      if (Object.prototype.hasOwnProperty.call(state.privileges, 'not_connected')) {
        if (type) {
          return state.privileges.not_connected.filter(privilege => privilege.type === type)
        }

        return state.privileges.not_connected
      }

      return []
    },
    getNextStepPrivilege: state => symbolName => {
      if (Object.prototype.hasOwnProperty.call(state.nextStep, 'privileges')) {
        return state.nextStep.privileges.find(privilege => privilege.symbol_name === symbolName)
      }

      return null
    },
    getNextStepPrivilegesWithoutDiscount: state => {
      if (Object.prototype.hasOwnProperty.call(state.nextStep, 'privileges')) {
        return state.nextStep.privileges.filter(p => p.type !== constants.PRIVILEGE_TYPE_DISCOUNT)
      }

      return []
    },
    isServiceNotConnected: state => service => {
      if (Object.prototype.hasOwnProperty.call(state.services, 'not_connected')) {
        return state.services.not_connected.includes(service)
      }

      return null
    }
  }
}
